// extracted by mini-css-extract-plugin
export default {"TrackCompetitors__itemlist":"FUynr2VJg79BbOChYb7r","TrackCompetitors__item":"YcTOLPVl023ZNUVBECtf","TrackCompetitors__imgbox":"SKMEYgojqzFNAcjTuwm8","TrackCompetitors__image":"ZB5f_Z9NhKMRgeRVes6T","TrackCompetitors__textbox":"o97894YiEjmXTlrpBrOw","TrackCompetitors__button":"tEbhmqbih40BLp07m2zf"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"TrackCompetitors__itemlist\":\"FUynr2VJg79BbOChYb7r\",\"TrackCompetitors__item\":\"YcTOLPVl023ZNUVBECtf\",\"TrackCompetitors__imgbox\":\"SKMEYgojqzFNAcjTuwm8\",\"TrackCompetitors__image\":\"ZB5f_Z9NhKMRgeRVes6T\",\"TrackCompetitors__textbox\":\"o97894YiEjmXTlrpBrOw\",\"TrackCompetitors__button\":\"tEbhmqbih40BLp07m2zf\"}";
        // 1775474909577
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  